<script lang="ts">// The bill laid out exactly like Supreme's old "Bill / Receipt" (Verdana, black on white, the centre's name
// and phones centred on top, a QR code, the patient block, the tests table, then sub total, due, discount,
// paid, received by, total, the notes and the signatory). Shared by the staff print view (BillPrint.svelte,
// the full CentreSettings) and the patient's public page (PublicBill.svelte, just these four fields).
let { bill, centre, patientNo, qr = "", provisional = false } = $props();
const lines = $derived((bill.items ?? []).filter((l) => l.status !== "cancelled"));
const notes = $derived((centre.bill_footer ?? "").split("\n").map((l) => l.trim()).filter(Boolean));
const amount = (v) => Number(v).toFixed(2);
const title = (g) => (g === "male" ? "Mr." : "Mrs.");
const ageText = $derived((bill.patient_age ?? "").replace(/\s*Y$/i, " yrs."));
const billDate = $derived(bill.bill_date.split("-").reverse().join("-"));
export {};
</script>

<div class="receipt">
  <div class="head">
    <h1>{centre.legal_name}</h1>
    <p>{centre.address}</p>
    {#if centre.phones}<p>Mobile: {centre.phones}</p>{/if}
  </div>

  <table class="top">
    <tbody><tr>
      <th class="l">Invoice No. : {bill.legacy_no ? `#000${bill.legacy_no}` : bill.invoice_no}</th>
      <th class="c">Bill / Receipt</th>
      <th class="r">Date : {billDate}</th>
    </tr></tbody>
  </table>
  <hr />
  {#if provisional}<p class="provisional">Provisional bill, made offline. The final bill number is given when it reaches CIDMS.</p>{/if}

  <table class="patient">
    <tbody>
      <tr>
        <td><span class="k">Patient Name</span>: <strong class="up">{title(bill.patient_gender)}{bill.patient_name}</strong>
          <span class="gap"></span><span class="up">{ageText}/{bill.patient_gender}</span></td>
        <td rowspan="4" class="qr">{#if qr}<img src={qr} alt="" width="70" height="70" />{/if}</td>
      </tr>
      <tr><td><span class="k">Patient ID</span>: {patientNo}</td></tr>
      <tr><td><span class="k">Mobile</span>: {bill.patient_mobile ? `+91${bill.patient_mobile.replace(/\D/g, "").slice(-10)}` : ""}
        <span class="gap2"></span><span class="k2">Consultant :</span> <span class="up">{bill.referring_doctor_name || "SELF"}</span></td></tr>
      <tr><td><span class="k">Address</span>: {bill.patient_address}</td></tr>
    </tbody>
  </table>

  <table class="items">
    <thead><tr><th style="width: 5%">#</th><th style="width: 50%">Test Name</th><th>Qty</th><th>Unit Amount</th><th>Total Amount</th></tr></thead>
    <tbody>
      {#each lines as l, i (l.id)}
        <tr><td>{i + 1}</td><td>{l.test_name}</td><td class="mono">{l.quantity}</td><td class="mono">{amount(l.unit_price)}</td><td class="mono">{amount(l.amount)}</td></tr>
      {/each}
      <tr><td colspan="4" class="mono b r subt">Sub Total :</td><td class="mono b subt">{amount(bill.subtotal)}</td></tr>
      <tr>
        <td></td>
        <td class="due">Due Amount : Rs - {amount(bill.due)}</td>
        {#if Number(bill.discount_amount) > 0}<td colspan="2" class="mono r">Disc :</td><td class="mono">{amount(bill.discount_amount)}</td>{:else}<td></td><td></td>{/if}
      </tr>
      <tr><td></td><td colspan="3" class="mono r">Paid Amt :</td><td class="mono">{amount(bill.paid)}</td></tr>
      <tr><td colspan="4" class="line"></td><td class="line"></td></tr>
      <tr><td></td><td>Recieved by - {bill.created_by_name}</td><td></td><td class="mono b r">Total Amt :</td><td class="mono b">{amount(bill.total)}</td></tr>
    </tbody>
  </table>

  {#if bill.status === "cancelled"}<p class="cancelled">CANCELLED: {bill.cancel_reason}</p>{/if}

  <div class="foot">
    {#if notes.length}
      <h6>Note :</h6>
      <ol>{#each notes as n, i (i)}<li>{n}</li>{/each}</ol>
    {/if}
    <div class="sign"><span></span><span>Thank you for visiting us.</span><span class="signatory">Authorized Signatory</span></div>
  </div>
</div>

<style src="./styles/BillSheet.css">  :global(body.is-printout) { background: #fff !important; }
  .receipt { width: 190mm; margin: 0 auto 32px; padding: 8mm 10mm; background: #fff; color: #000; font-family: Verdana, Geneva, Tahoma, sans-serif; font-size: 13px; }
  .head { text-align: center; }
  .head h1 { font-family: Verdana, Geneva, Tahoma, sans-serif; font-size: 26px; font-weight: 700; color: #000; margin: 0 0 4px; letter-spacing: 0; }
  .head p { font-family: "Courier New", Courier, monospace; font-size: 14px; margin: 0; }
  table { width: 100%; border-collapse: collapse; }
  .top th { font-family: Verdana, Geneva, Tahoma, sans-serif; padding: 6px 0 2px; color: #000; background: none; font-size: 13px; }
  .top .l { text-align: left; width: 30%; } .top .c { text-align: center; font-size: 18px; width: 40%; } .top .r { text-align: right; font-size: 12px; width: 30%; }
  hr { margin: 0; border: 0; border-top: 1px solid #000; }
  .provisional { margin: 4px 0 0; font-size: 11px; font-style: italic; text-align: center; }
  .patient td { padding: 3px 0; font-size: 13px; line-height: 1.5; vertical-align: top; overflow-wrap: break-word; }
  /* Fixed width, left-aligned, with the colon outside the box: every label starts at the same x, and
     the colon (right after the fixed-width box) lands at the same x too, regardless of label length. */
  .patient .k { display: inline-block; width: 108px; margin-right: 5px; font-weight: bold; text-align: left; white-space: nowrap; }
  .patient .k2 { font-weight: bold; }
  .up { text-transform: uppercase; }
  .gap { display: inline-block; width: 40px; }
  .gap2 { display: inline-block; width: 24px; }
  .patient td:first-child { padding-right: 14px; }
  .qr { text-align: right; width: 100px; padding-left: 14px; vertical-align: middle; }
  .qr img { display: block; margin-left: auto; }
  .items { margin-top: 6px; border-top: 1px solid #000; }
  .items th { text-align: left; font-size: 13px; font-family: Verdana; border-bottom: 1px solid #000; padding: 2px; color: #000; background: none; font-weight: bold; }
  .items td { font-size: 13px; padding: 7px 2px 5px; }
  .mono { font-family: "Courier New", Courier, monospace; }
  .b { font-weight: bold; } .r { text-align: right; }
  .subt { border-top: 1px solid #000; }
  .due { text-align: right; font-size: 17px; font-weight: bold; padding-right: 30px !important; }
  .line { border-bottom: 1px solid #000; padding: 0 !important; }
  .cancelled { margin: 10px 0 0; font-weight: bold; color: #b00; }
  .foot h6 { margin: 8px 0 2px; font-size: 12px; }
  .foot ol { font-size: 12px; font-weight: bold; margin: 0; padding-left: 20px; }
  .sign { display: flex; justify-content: space-between; align-items: flex-end; margin-top: 30px; font-size: 13px; font-weight: bold; }
  .signatory { border-top: 1px solid #000; padding-top: 2px; }
  /* Screen only, on phones and small tablets: the same receipt, fitted to the screen (paper is unchanged). */
  @media screen and (max-width: 800px) {
    .receipt { width: 100%; max-width: 190mm; box-sizing: border-box; margin: 12px auto 24px; padding: 14px 12px; font-size: 12px;
      box-shadow: 0 1px 3px rgb(0 0 0 / .12); overflow-wrap: anywhere; }
    .head h1 { font-size: 20px; }
    .head p { font-size: 12px; }
    .top .c { font-size: 15px; } .top .l, .top .r { font-size: 11px; }
    .patient td, .items td, .items th { font-size: 12px; }
    .gap { width: 12px; } .gap2 { width: 8px; }
    .patient .k { width: 92px; }
    .due { font-size: 14px; padding-right: 8px !important; }
    :global(body.is-printout) { background: var(--muted) !important; }
  }
  /* Compact enough that a bill's receipt fits comfortably in half an A4 page (tight spacing, smaller
     type): print one, feed the same sheet back, and print the next bill on the other half. */
  @media print {
    .receipt { width: auto; margin: 0; padding: 0; font-size: 11px; }
    .head h1 { font-size: 20px; margin-bottom: 2px; }
    .head p { font-size: 12px; }
    .top th { padding: 3px 0 1px; font-size: 11px; }
    .top .c { font-size: 15px; } .top .r { font-size: 10px; }
    .provisional { margin-top: 2px; font-size: 9px; }
    /* A guaranteed gap below the <hr> above it, rather than relying on the QR cell's own padding. */
    .patient { margin-top: 4px; }
    .patient td { padding: 1px 0; font-size: 11px; line-height: 1.25; }
    .patient .k { width: 88px; }
    /* Smaller than the 4 compact rows are tall, so vertical-align: middle has room to centre it,
       leaving even space above and below instead of the QR forcing the row height itself. */
    .qr img { width: 50px; height: 50px; }
    .items { margin-top: 3px; }
    .items th { font-size: 11px; padding: 1px; }
    .items td { font-size: 11px; padding: 3px 2px 2px; }
    .due { font-size: 13px; }
    .foot h6 { margin: 4px 0 1px; }
    .foot ol { font-size: 10px; }
    /* Enough room for a pen signature, without being excessive. */
    .sign { margin-top: 14mm; font-size: 11px; }
  }
  /* No forced size/margin here: an @page size locks the browser's own "Paper size" and margin
     controls in the print dialog, so paper choice is left to whoever prints. */
  @page { margin: 6mm; }
</style>
